"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFileUpload = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_dropzone_1 = require("react-dropzone");
var AcButton_1 = require("../button/AcButton");
var AcToast_1 = require("../notification/AcToast");
var AcFileUpload = function (_a) {
    var handleCancel = _a.handleCancel, onFileUpload = _a.onFileUpload, maxFileSize = _a.maxFileSize, _b = _a.allowedExtensions, allowedExtensions = _b === void 0 ? ['.pdf'] : _b, isAbsoluteButton = _a.isAbsoluteButton;
    var onDrop = react_1.useCallback(function (acceptedFiles) {
        acceptedFiles.forEach(function (file) {
            var reader = new FileReader();
            reader.onabort = function () { return console.error('file reading was aborted'); };
            reader.onerror = function () { return console.error('file reading has failed'); };
            reader.onload = function () {
                // Do whatever you want with the file contents
                var binaryStr = reader.result;
                onFileUpload(file, binaryStr);
            };
            reader.readAsArrayBuffer(file);
        });
        // Do something with the files
    }, []);
    var onDropRejected = function (errorList) {
        errorList.forEach(function (el) {
            el.errors.forEach(function (e) {
                if (e.code === 'file-too-large') {
                    var sizeInMB = maxFileSize ? Math.round(maxFileSize / 1000000) : 0;
                    AcToast_1.notifyMessage(sizeInMB + "MB\u3092\u8D85\u904E\u3057\u3066\u3044\u307E\u3059\u3002", 'ERROR');
                }
                else if (e.code === 'file-invalid-type') {
                    AcToast_1.notifyMessage("\u6709\u52B9\u306A" + allowedExtensions.join(',') + "\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002", 'ERROR');
                }
                else {
                    AcToast_1.notifyMessage(e.message, 'ERROR');
                }
            });
        });
    };
    var _c = react_dropzone_1.useDropzone({
        accept: allowedExtensions,
        onDrop: onDrop,
        onDropRejected: onDropRejected,
        maxSize: maxFileSize,
    }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragAccept = _c.isDragAccept, isDragReject = _c.isDragReject, isDragActive = _c.isDragActive;
    return (react_1.default.createElement("div", { className: "w-100 h-100 position-relative d-flex justify-content-center align-items-center" },
        react_1.default.createElement("div", __assign({ className: "w-100" }, getRootProps()),
            react_1.default.createElement("input", __assign({}, getInputProps())),
            react_1.default.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center border-4 rounded border-dashed border-white " + (isDragAccept ? 'bg-light text-dark' : 'text-white') + " flex-grow-1", style: { height: '350px', cursor: 'pointer' } },
                isDragAccept && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { className: "mb-8" },
                        react_1.default.createElement("i", { className: "fal fa-file-upload", style: { fontSize: '50px' } })),
                    react_1.default.createElement("p", { className: "fs-18" }, "All files will be accepted"))),
                (isDragReject || !isDragActive) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { className: "mb-8" },
                        react_1.default.createElement("i", { className: "fal fa-file-pdf", style: { fontSize: '50px' } })),
                    react_1.default.createElement("p", { className: "fs-18 mb-2 text-center" },
                        "PDF\u30C7\u30FC\u30BF\u3092\u30C9\u30E9\u30C3\u30B0\uFF06\u30C9\u30ED\u30C3\u30D7",
                        react_1.default.createElement("br", null),
                        "\u307E\u305F\u306F\u3001\u3053\u3061\u3089\u304B\u3089\u9078\u629E\u3057\u3066\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9"),
                    react_1.default.createElement("p", { className: "fs-12", style: { opacity: '0.8' } }, "\u9001\u4FE1\u53EF\u80FD\u306A\u30D5\u30A1\u30A4\u30EB\u30B5\u30A4\u30BA\u306E\u4E0A\u9650\u306F10MB\u3067\u3059\u3002"))))),
        react_1.default.createElement("div", { className: clsx_1.default('text-center w-100', !isAbsoluteButton && 'position-fixed', isAbsoluteButton && 'position-absolute'), style: { bottom: 40, left: 0 } },
            react_1.default.createElement(AcButton_1.AcButton, { size: "xl", variant: "outline-light", className: "rounded-lg", onClick: handleCancel }, "\u30AD\u30E3\u30F3\u30BB\u30EB"))));
};
exports.AcFileUpload = AcFileUpload;
exports.AcFileUpload.displayName = 'AcFileUpload';
//# sourceMappingURL=AcFileUpload.js.map